<template>
  <v-form
    ref="form"
    v-model="formValid"
    @submit.prevent="beforeSave()"
  >
    <page-template>
      <template slot="title">
        <page-title
          :title="$t('app.tecfinOffer.manage.title')"
          navigate-back-route="Contratacoes"
        />
      </template>
      <template slot="content">
        <v-container
          class="py-0"
          fluid
          grid-list-sm
        >
          <form-group :title="$t('app.tecfinOffer.manage.subTitle')">
            <v-layout
              class="justify-end"
              wrap
            >
              <v-flex
                xs12
                lg12
              >
                <v-layout
                  class="justify-end"
                  justify-end
                >
                  <v-flex
                    xs12
                    md12
                    lg4
                  >
                    <p>{{ $t("app.tecfinOffer.manage.form.actions.title") }}</p>
                    <input-radio
                      v-model="payload.action"
                      :options="actionOptions"
                      row
                    />
                  </v-flex>
                </v-layout>
                <v-layout
                  class="justify-end"
                >
                  <v-flex
                    xs12
                    lg8
                  >
                    <date-interval
                      v-model="dataDeVigencia"
                      input-key="dataDeVigencia"
                      identifier="dataDeVigencia"
                      :initial-date-label="$t('app.tecfinOffer.manage.form.initialDate')"
                      :final-date-label="$t('app.tecfinOffer.manage.form.finalDate')"
                      required
                    />
                  </v-flex>
                </v-layout>
                <v-layout
                  class="justify-end"
                >
                  <v-flex
                    xs12
                    lg8
                  >
                    <input-text
                      v-model="payload.data.empresa"
                      required
                      mask="###"
                      width="100px"
                      :rules="[minLength(3)]"
                      :label="$t('app.tecfinOffer.manage.form.company')"
                    />
                  </v-flex>
                </v-layout>
                <v-layout
                  class="justify-end"
                >
                  <v-flex
                    xs12
                    lg12
                  >
                    <input-text-area
                      v-model="clientes"
                      required
                      :rules="[onlyNumbersCommaSpace()]"
                      :label="$t('app.tecfinOffer.manage.form.client')"
                      :rows="10"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </form-group>
          <v-divider class="my-4" />
          <v-flex class="py-3 text-xs-right">
            <btn-cancel
              :text="$t('support.components.crudForm.btnCancel')"
              @click="navigateTo('Contratacoes')"
            />
            <btn-primary
              :text="$t('support.components.crudForm.btnConfirm')"
              type="submit"
            />
          </v-flex>
          <v-dialog
            v-model="loadingForm"
            hide-overlay
            persistent
            width="300"
          >
            <v-card
              color="primary"
              dark
            >
              <v-container
                grid-list-md
                text-xs-center
              >
                <v-card-text class="text-center">
                  Aguardando resposta do SGV...
                </v-card-text>
                <v-flex xs12>
                  <v-card-text class="px-0">
                    <v-progress-circular
                      indeterminate
                      color="white"
                      class="mb-0"
                    />
                  </v-card-text>
                </v-flex>
              </v-container>
            </v-card>
          </v-dialog>
        </v-container>
      </template>
    </page-template>
  </v-form>
</template>

<script>
import FormGroup from 'Support/layout/FormGroup.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import InputRadio from 'Support/components/inputs/InputRadio.vue';
import PageTemplate from 'Support/layout/PageTemplate.vue';
import PageTitle from 'Support/layout/PageTitle.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import BtnCancel from 'Support/components/buttons/BtnCancel.vue';
import FormMixin from 'Support/components/crud/form-mixin';
import RouterMixin from 'Support/mixins/router-mixin';
import NotificationMixin from 'Support/mixins/notification-mixin';
import ManageOfferRequest from 'Domain/tecfin-offer/ManageOfferRequest';

import InputText from 'Support/components/inputs/InputText.vue';
import InputTextArea from 'Support/components/inputs/InputTextArea.vue';
import DateInterval from 'Support/components/reports/DateInterval.vue';
import Moment from 'moment';

export default {
  name: 'ManageOfferForm',
  components: {
    PageTemplate,
    PageTitle,
    FormGroup,
    InputText,
    InputTextArea,
    DateInterval,
    InputRadio,
    BtnPrimary,
    BtnCancel,
  },
  mixins: [RulesMixin, FormMixin, RouterMixin, NotificationMixin],
  data: vm => ({
    requestClass: ManageOfferRequest,
    navigateToPageAfterSave: 'ManageOffer',
    payload: {
      action: true,
      data: {
        empresa: '',
        clientes: [],
        vigenciaFinal: '',
        vigenciaInicial: '',
      },
    },
    dataDeVigencia: {
      dataInicial: '',
      dataFinal: '',
    },
    actionOptions: [
      {
        label: vm.$t('app.tecfinOffer.manage.form.actions.include'),
        value: true,
      },
      {
        label: vm.$t('app.tecfinOffer.manage.form.actions.exclude'),
        value: false,
      },
    ],
    clientes: '',
    loading: false,
  }),
  watch: {
    dataDeVigencia: {
      deep: true,
      handler(value) {
        this.payload.data.vigenciaInicial = value.dataInicial;
        this.payload.data.vigenciaFinal = value.dataFinal;
      },
    },
    clientes: {
      handler(value) {
        this.payload.data.clientes = value.split(',');
      },
    },
  },
  created() {
    this.dataDeVigencia.dataInicial = Moment(new Date()).format('YYYY-MM-DD');
  },
  methods: {
    create() {
      this.loadingForm = true;
      this.requestClass
        .save(this.getCreatePayload())
        .then((result) => {
          if (result) {
            const { data } = result;
            const offersAffected = this.payload.action ? data.quantidadeDeOfertasCriadas
              : data.quantidadeDeOfertasDeletadas;
            if (offersAffected === 0) {
              this.showErrorToast({
                text: data.mensagem,
              });
            } else {
              this.showSuccessToast({
                text: data.mensagem,
              });
            }
          }
          this.afterSave();
        })
        .catch(({ response }) => {
          this.showMessageError(response);
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    confirmarAcao(title, text, callbackFn) {
      this.showConfirmDialog({
        title,
        text,
        width: '35em',
        confirmButtonText: this.$t('app.contratacoes.list.confirm'),
        cancelButtonText: this.$t('app.contratacoes.list.cancel'),
      })
        .then((data) => {
          if (data.value) {
            callbackFn();
          }
        });
    },
    confirmarAcaoRemover() {
      this.confirmarAcao(
        this.$t('app.tecfinOffer.manage.form.dialog.title'),
        this.$t('app.tecfinOffer.manage.form.dialog.message'),
        this.save,
      );
    },
    onlyNumbersCommaSpace() {
      return (v) => {
        const regex = /^[-,0-9]+$/gi;
        return regex.test(v) || this.$t('app.tecfinOffer.manage.form.validations.commaAndNumbers');
      };
    },
    beforeSave() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.payload.action) {
        this.confirmarAcaoRemover();
      } else {
        this.save();
      }
    },
  },
};
</script>
